import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ClaimManagerFrontend} from '../../environments/application-configurations';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SelectedYearProvider {
  private readonly claimManagerFrontend: ClaimManagerFrontend = environment.claimManagerFrontend;
  private readonly yearKey: string = `UI_SelectedYear_${this.claimManagerFrontend.baseUrl}`;
  private readonly selectedYearSubject: Subject<number> = new Subject<number>();
  private _year: number = new Date().getFullYear();
  public readonly selectedYear: Observable<number> = this.selectedYearSubject.asObservable();
  private afterSelectedYearLoaded: (() => void) | undefined = () => document.location.reload();

  constructor() {
    let storedSelectedYearPreference = localStorage.getItem(this.yearKey);
    if (storedSelectedYearPreference === null) {
      storedSelectedYearPreference = JSON.stringify(new Date().getFullYear());
    }
    console.debug(`storedSelectedYearPreference: ${storedSelectedYearPreference}`)
    const storedSelectedYear: number = JSON.parse(storedSelectedYearPreference ?? JSON.stringify(new Date().getFullYear())) as number;
    this.selectedYear.subscribe(year => this._year = year);
    this.selectedYear.subscribe(year => localStorage.setItem(this.yearKey, JSON.stringify(year)));
    this._year = storedSelectedYear;
  }

  public setSelectedYear(year: number, callback: (() => void) | undefined = undefined) {
    this.selectedYearSubject.next(year);
    this.afterSelectedYearLoaded = callback ?? this.afterSelectedYearLoaded;
    if (this.afterSelectedYearLoaded) this.afterSelectedYearLoaded();
  }

  public get year(): number {
    return this._year;
  }
}
